import LegalPage from "@/pages/LegalPage";

const SECTIONS = [
  {
    h: "Acceptance of Terms",
    p: [
      "These Terms and Conditions govern your access to and use of the Trainova website and application. By joining our waitlist, contacting us, or using Trainova, you agree to be bound by these terms. If you do not agree, please do not use the service.",
    ],
  },
  {
    h: "Eligibility",
    p: [
      "You must be at least 18 years old (or the age of majority in your jurisdiction) to create an account and use Trainova. By using the service, you confirm that the information you provide is accurate and that you meet these requirements.",
    ],
  },
  {
    h: "Using Trainova",
    p: ["When using Trainova, you agree to:"],
    list: [
      "Provide accurate profile, goal and preference information.",
      "Treat other members with respect and communicate appropriately.",
      "Use the matching and messaging features for their intended purpose of finding a training partner.",
      "Comply with all applicable laws and gym or facility rules.",
    ],
  },
  {
    h: "Prohibited Conduct",
    p: ["You agree not to:"],
    list: [
      "Harass, threaten, or harm other members.",
      "Impersonate any person or misrepresent your identity or affiliation.",
      "Use the service for any unlawful, fraudulent, or commercial solicitation purpose.",
      "Attempt to disrupt, reverse engineer, or gain unauthorized access to the service.",
    ],
  },
  {
    h: "Health & Fitness Disclaimer",
    p: [
      "Trainova connects you with training partners; it does not provide medical, health, or professional fitness advice. Always consult a qualified professional before beginning any exercise program. You train with partners at your own risk, and you are responsible for your own safety and wellbeing.",
    ],
  },
  {
    h: "Accounts & Termination",
    p: [
      "You are responsible for maintaining the confidentiality of your account. We may suspend or terminate accounts that violate these terms. You may delete your account at any time via Side Bar > Settings > Delete Account, or by emailing support@trainovaapp.com.",
    ],
  },
  {
    h: "Intellectual Property",
    p: [
      "All content, branding, logos and software associated with Trainova are owned by Trainova Fitness and protected by applicable intellectual property laws. You may not copy, modify or distribute our content without permission.",
    ],
  },
  {
    h: "Limitation of Liability",
    p: [
      "To the maximum extent permitted by law, Trainova is provided \"as is\" without warranties of any kind. Trainova Fitness is not liable for any indirect, incidental or consequential damages arising from your use of the service or interactions with other members.",
    ],
  },
  {
    h: "Changes to These Terms",
    p: [
      "We may update these Terms from time to time. Continued use of Trainova after changes take effect constitutes acceptance of the revised terms.",
    ],
  },
];

export default function Terms() {
  return (
    <LegalPage
      testid="terms-page"
      eyebrow="THE GROUND RULES"
      title="Terms &"
      accent="conditions"
      subtitle="The terms that govern your use of Trainova and our community."
      updated="June 2026"
      sections={SECTIONS}
    />
  );
}
